import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const RadioInputClassBase = css<{ theme: StyledTheme }>`
  .radio-label {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    position: relative;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.primary.color};
    cursor: pointer;

    .radio-input {
      display: none;
      width: 0px;
      height: 0px;
    }

    .radio-layout {
      border: 1px solid ${({ theme }) => theme.palette.primary.color};
      border-radius: 9999px;
      width: 1.25rem;
      height: 1.25rem;
      margin-top: 0.125rem;
      left: 0;
      top: 0;
      position: absolute;

      .radio-inner-layout {
        background-color: ${({ theme }) => theme.palette.primary.color};
        border: 2px solid
          ${({ theme }) => theme.palette.primaryBackground.color};
        border-radius: 9999px;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }

    .radio-input-label,
    .radio-input-inlay {
      padding-left: 2.5rem;
      font-weight: 400;
      color: ${({ theme }) => theme.palette.primary.color};
    }
  }
`;
